'use strict';

(function () {
  'use strict';

  angular.module('msUtility').factory('msSmoothScroll', msSmoothScroll);

  msSmoothScroll.$inject = ['$document'];

  var STOP_ANI = true;
  var scrollTween = void 0;

  function msSmoothScroll($document) {
    return {
      scrollTo: scrollTo,
      scrollToEl: scrollToEl
    };

    function scrollTo(scrollElement, scrollLeft, scrollTop) {
      _runScrollAnimation(_evalTargetEl(scrollElement), _preScroll(_evalTargetEl(scrollElement)), _postScrollTo(scrollLeft, scrollTop));
    }

    function scrollToEl(scrollElement, targetEl, offsetLeft, offsetTop, anchorBottom) {
      _runScrollAnimation(_evalTargetEl(scrollElement), _preScroll(_evalTargetEl(scrollElement)), _postScrollToEl(_evalTargetEl(targetEl), offsetLeft, offsetTop, anchorBottom));
    }

    ////////////////

    function _runScrollAnimation(scrollElement, preScroll, postScroll) {
      // If this element is currently scrolling, stop it before scrolling to the new location.
      if (scrollTween) {
        scrollTween.stop();
      }
      scrollTween = new TWEEN.Tween(preScroll).to(_.omitBy(postScroll, _.isNil)).easing(TWEEN.Easing.Cubic.InOut).onUpdate(function (scrollObject) {
        // If we are scrolling the <body> element, we need to apply different scrolling methods for different browsers.
        if (scrollElement[0].nodeName === 'BODY') {
          $document[0].documentElement.scrollLeft = $document[0].body.scrollLeft = scrollObject.scrollLeft;
          $document[0].documentElement.scrollTop = $document[0].body.scrollTop = scrollObject.scrollTop;
        } else if (scrollElement[0]) {
          scrollElement[0].scrollLeft = scrollObject.scrollLeft;
          scrollElement[0].scrollTop = scrollObject.scrollTop;
        }
      }).onComplete(function () {
        return STOP_ANI = true;
      });

      STOP_ANI = false;
      _animate();
      scrollTween.start();
    }

    // If el is a string, interpret it as a querySelector. Otherwise, return el.
    function _evalTargetEl(el) {
      return _.isString(el) ? angular.element($document[0].querySelector(el)) : el;
    }

    // Initial scroll position of scrollElement
    function _preScroll(scrollElement) {
      // If we are scrolling the <body> element, we need to apply different scrolling methods for different browers.
      if (scrollElement[0].nodeName === 'BODY') {
        return {
          scrollLeft: $document[0].documentElement.scrollLeft || $document[0].body.scrollLeft || 0,
          scrollTop: $document[0].documentElement.scrollTop || $document[0].body.scrollTop || 0
        };
      } else if (scrollElement[0]) {
        return {
          scrollLeft: scrollElement[0].scrollLeft,
          scrollTop: scrollElement[0].scrollTop
        };
      }
    }

    // Final scroll position of scrollElement
    function _postScrollTo(scrollLeft, scrollTop) {
      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }

    // Final scroll position of scrollElement
    function _postScrollToEl(targetEl, offsetLeft, offsetTop, anchorBottom) {
      return {
        scrollLeft: _.get(targetEl[0], 'offsetLeft') + offsetLeft + (anchorBottom ? _.get(targetEl[0], 'offsetWidth') : 0),
        scrollTop: _.get(targetEl[0], 'offsetTop') + offsetTop + (anchorBottom ? _.get(targetEl[0], 'offsetHeight') : 0)
      };
    }

    // Recursive loop that calls TWEEN.update() ~60 times per second.
    // TWEEN.update() increases the values of all the active Tweens, moving all animations to the next frame.
    function _animate() {
      if (STOP_ANI) {
        return;
      }
      TWEEN.update();
      requestAnimationFrame(_animate);
    }
  }
})();